<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.items.length">
                <div :class="[this.gridClassArray, 'link-buttons', 'theme-accent-border-color']">
                  <template v-for="(item, index) in contents.items">
                    <template v-if="item.pageId">
                      <div>
                        <a class="link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold"><i :class="['block', 'fa', ' fa-' + item.icon]" aria-hidden="true"></i>{{ getPageById(item.pageId).title.rendered }}</a>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <a class="link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold">ページを選択してください</a>
                      </div>
                    </template>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">リンクを追加してください</span>
                </div>
              </template>
            </div>
          </section>
        </div>
      </div>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="内部リンク" :label-width="labelWidth">
          <template v-for="(item, index) in contents.items">
            <div class="flex">
              <el-select class="width-20" v-model="contents.items[index].icon" placeholder="アイコンリストから選択" style="display:inline-block;">
                <el-option class="el-opp"
                  v-for="icon in icons"
                  :key="icon.value"
                  :label="icon.label"
                  :value="icon.value">
                  <span style="display:inline-block;width:2em">
                    <i :class="['fa', ' fa-' + icon.value]" aria-hidden="true" style="font-size:1.5em;"></i>
                  </span>
                  <span style="float:right">{{ icon.value }}</span>
                </el-option>
              </el-select>
              <el-select class="width-50 ml1" value-key="link" v-model="contents.items[index].pageId" placeholder="固定ページから選択" style="display:inline-block;">
                <el-option class="el-opp"
                  v-for="page in publishedPages"
                  :key="page.link"
                  :label="page.title.rendered"
                  :value="page.id">
                </el-option>
              </el-select>
              <el-button class="width-20 ml1" @click="onDeleteLink(index)">リンクの削除</el-button>
            </div>
          </template>
          <el-button class="my1" @click="onAddLink">リンクボタンの追加</el-button>
        </el-form-item>
        <el-form-item label="スマホサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.s" controls-position="right" :min="1" :max="2"></el-input-number><span class="pl4">最大2まで</span>
        </el-form-item>
        <el-form-item label="タブレットサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.m" controls-position="right" :min="1" :max="4"></el-input-number><span class="pl4">最大4まで</span>
        </el-form-item>
        <el-form-item label="デスクトップサイズで横に並べるリンクボタンの数" :label-width="labelWidth">
          <el-input-number v-model="contents.layout.l" controls-position="right" :min="1" :max="6"></el-input-number><span class="pl4">最大6まで</span>
        </el-form-item>
        <!-- <el-form-item label="リンクボタン間の余白" :label-width="labelWidth">
           <el-slider v-model="contents.layout.margin" :step="1" :min="0" :max="5"></el-slider>
        </el-form-item> -->
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import {getFontawesomeIcons} from '@/helpers'

export default {
  name: 'link-buttons-2',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '20em',
      icons: getFontawesomeIcons()
    }
  },
  methods: {
    onAddLink: function () {
      this.contents.items.push({
        icon: 'car',
        pageId: null,
        color: ''
      })
    },
    onDeleteLink: function (index) {
      this.contents.items.splice(index, 1)
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const linkButtons = contents.items.reduce((acc, item) => {
        const blank = item.blank ? 'target="_blank"' : ''
        return acc + (`<div><a class="link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold page-id-${this.getPageById(item.pageId).id}" href="${this.getPageById(item.pageId).link}" ${blank}><i class="block fa fa-${item.icon}" aria-hidden="true"></i>${this.getPageById(item.pageId).title.rendered}</a></div>`)
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <div class="${this.gridClass} link-buttons theme-accent-border-color">
            ${linkButtons}
          </div>
        </div>
      </section>`.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      theme = contents.items.reduce((acc, item) => {
        return acc + `body.page-id-${this.getPageById(item.pageId).id} .${this.meta.file}-${this._uid} .link-button.page-id-${this.getPageById(item.pageId).id} {color: #fff; ${this.getThemeInlineStyle('background-color', 'accent')}}`
      }, theme)
      return {layout, theme}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import './LinkButtons2.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './LinkButtons2.s.scss';
}
.tablet,
.desktop {
  @import './LinkButtons2.m.scss';
}
.desktop {
  @import './LinkButtons2.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/LinkButtons2/LinkButtons2.vue